import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material'
import React, { useState } from 'react'
import QRCode from 'react-qr-code'
import { Verified } from '@mui/icons-material'
import { parse } from 'date-fns'
import { formatValueDateTime } from '../../../Functions/FormatValues'

function ValidateTime() {
  const [anchorEl, setAnchorEl] = useState<any>(null)
  const [outcome, setOutcome] = useState<any>(null)
  return (
    <>
      <Button
        variant={'outlined'}
        startIcon={<Verified />}
        size={'small'}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        Validate Timestamp
      </Button>
      <Dialog open={!!anchorEl}>
        <DialogTitle>Scan to confirm correct and working timestamp</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Box
              sx={{
                mr: 2,
                display: 'flex',
                flexDirection: 'column',
                maxWidth: 500,
              }}
            >
              <TextField
                sx={{ mt: 1 }}
                fullWidth
                label="Scan QR code"
                onKeyDown={(e: any) => {
                  if (e.key === 'Enter' || e.key === 'NumpadEnter') {
                    const readerTime = parse(
                      e.target.value.substring(6, 50),
                      'yyyy/MM/dd HH:mm:ss',
                      new Date(),
                    )
                    if (e.target.value.startsWith('12345')) {
                      const sec_diff = Math.abs(
                        (readerTime.getTime() - new Date().getTime()) / 1000,
                      )
                      if (sec_diff < 60) {
                        setOutcome({
                          color: 'green',
                          message: `Time stamp is correct (Less than 60 second difference).`,
                        })
                      } else {
                        setOutcome({
                          color: 'red',
                          message: `Current time is ${formatValueDateTime(new Date())}, but reader time is ${formatValueDateTime(readerTime)}. A difference of ${sec_diff} seconds exists.`,
                        })
                      }
                    } else {
                      setOutcome({ color: 'error', message: 'Incorrect data' })
                    }
                  }
                }}
              />
              <Typography
                variant="caption"
                sx={{ mt: 1 }}
                color={outcome?.color}
              >
                {outcome?.message}
              </Typography>
            </Box>
            <QRCode
              size={100}
              style={{ height: '100px', width: '100px' }}
              value={'12345'}
              viewBox={`0 0 256 256`}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setAnchorEl(null)
              setOutcome(null)
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default ValidateTime
